import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    image: "./set-credentials-error.svg",
    altText: "set credentials error",
    title: "Sorry!",
    "contact-url": _ctx.contactUrl
  }, {
    action: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: _ctx.tryAgain }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Try Again")
        ])),
        _: 1,
        __: [0]
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode(" There was an issue with setting your password, please try again or ")),
      _createElementVNode("a", { href: _ctx.contactUrl }, "contact", 8, _hoisted_1),
      _cache[2] || (_cache[2] = _createTextVNode(" us. "))
    ]),
    _: 1,
    __: [1,2]
  }, 8, ["contact-url"]))
}